import { gql } from '@apollo/client';

export const NEARBY_LISTING_QUERY = gql`
  query ListingsQuery(
    $gteLatitudeValue: Decimal
    $lteLatitudeValue: Decimal
    $gteLongitudeValue: Decimal
    $lteLongitudeValue: Decimal
    $propertyTypeIdValue: Byte
    $currListingId: Int
  ) {
    listingSearch(
      where: {
        and: [
          { statusId: { in: [1, 5] } }
          { propertyTypeId: { eq: $propertyTypeIdValue } }
          { longitude: { neq: 0 } }
          { latitude: { neq: 0 } }
          { longitude: { gte: $gteLongitudeValue } }
          { longitude: { lte: $lteLongitudeValue } }
          { latitude: { gte: $gteLatitudeValue } }
          { latitude: { lte: $lteLatitudeValue } }
          { listingId: { neq: $currListingId } }
        ]
      }
      take: 500
      order: { listingId: ASC }
    ) {
      totalCount
      items {
        alerts {
          text
          type
          listingAlertId
          listingId
          __typename
        }
        listingId
        longitude
        latitude
        address
        city
        state
        zip
        statusId
        mainPhoto {
          midSizeImageUrl
        }
        openHouses {
          formattedDateTimeDisplay
        }
        price
        priceFormatted
        fullBathroomCount
        partBathroomCount
        bathroomCount
        bedroomCount
        squareFootage
      }
    }
  }
`;

export const NEARBY_SOLD_LISTING_QUERY = gql`
  query ListingsQuery(
    $gteLatitudeValue: Decimal
    $lteLatitudeValue: Decimal
    $gteLongitudeValue: Decimal
    $lteLongitudeValue: Decimal
    $propertyTypeIdValue: Byte
    $sellingDateValue: DateTime
    $currListingId: Int
  ) {
    listingSearch(
      where: {
        and: [
          { statusId: { eq: 6 } }
          { propertyTypeId: { eq: $propertyTypeIdValue } }
          { sellingDate: { gte: $sellingDateValue } }
          { longitude: { neq: 0 } }
          { latitude: { neq: 0 } }
          { longitude: { gte: $gteLongitudeValue } }
          { longitude: { lte: $lteLongitudeValue } }
          { latitude: { gte: $gteLatitudeValue } }
          { latitude: { lte: $lteLatitudeValue } }
          { listingId: { neq: $currListingId } }
        ]
      }
      take: 500
      order: { listingId: ASC }
    ) {
      totalCount
      items {
        alerts {
          text
          type
          listingAlertId
          listingId
          __typename
        }
        listingId
        longitude
        latitude
        address
        city
        state
        zip
        statusId
        mainPhoto {
          midSizeImageUrl
        }
        openHouses {
          formattedDateTimeDisplay
        }
        price
        priceFormatted
        fullBathroomCount
        partBathroomCount
        bathroomCount
        bedroomCount
        squareFootage
      }
    }
  }
`;
